<template>
	<div class="baseTable">
		<el-row>
			<el-col :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
				<div class="table-heading">
					<slot name="headingOfTable"></slot>
				</div>

				<div class="mb-2">
					<span v-if="$route.name === 'forecastLocation' || $route.name === 'forecastCategory' || $route.name === 'forecastCentralKitchen' || $route.name === 'Location' || $route.name === 'Category'"
						:class="[breadCrumbs.length > 0 ? 'cursor-pointer text-black capitalize text-sm hover:text-orange-dark' : 'text-grey-dark text-sm capitalize']" @click="defaultBreadcurmbClicked()">
						{{ $route.name == "forecastLocation" ? "Forecast Location" : $route.name == "forecastCategory" ? "Forecast Category" : $route.name == "forecastCentralKitchen" ? "Forecast Central Kitchen": $route.name}}

						<i class="el-icon-arrow-right" style="font-size: 15px;vertical-align: text-bottom;"></i>
					</span>

					<span v-for="(bread_curmb, index) in breadCrumbs" :key="index">
						<span
							v-for="(key, value, obj_index) in bread_curmb"
							:key="obj_index"
							class="capitalize"
						>
							<span :class="[value == active_breadCrumbs ? 'text-grey-dark text-sm' : 'cursor-pointer text-black text-sm hover:text-orange-dark']" class="capitalize" @click="breadCurmbClicked(value,key)">
								{{ value }}
							</span>
							<span v-if="index != breadCrumbs.length - 1">
								<i class="el-icon-arrow-right capitalize" style="font-size: 15px;vertical-align: text-bottom;"></i>
							</span>
						</span>
					</span>
				</div>
			</el-col>

			<el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
				<div class="table-sns">
					<div v-if="showViewDropdown" class="mr-2">
						<el-select
							v-model="salesView"
							style="width: 270px;"
							@change="onSalesViewChange(salesView)"
						>
							<template v-for="(view, index) in allSalesView">
								<el-option
									v-if="view.isVisible"
									:key="index"
									:value="view.id"
									:label="view.name"
								>
									{{ view.name }}
								</el-option>
							</template>
						</el-select>
					</div>
					<!-- <span class="cursor-pointer" @click="downloadCsvEvent()">
						<img
							width="24"
							height="24"
							src="https://img.icons8.com/ios/24/000000/export-csv.png"
						/>
					</span> -->
				</div>
			</el-col>
		</el-row>

		<div class="scroll">
			<table v-for="(data, index) in tableData" :key="index" class="tableMain">
				<thead>
					<tr v-if="data.headingMain">
						<th
							v-for="(mainHeading, index1) in data.headingMain"
							:key="index1"
							:colspan="mainHeading.colspan"
							:class="{
								'main-heading-spacing': mainHeading.isBorder
							}"
						>
							<!-- for show all approve button in main heading -->
							<div v-if="mainHeading.value == 'approve'">
								<button class="first-button" @click="rowButtonClicked(mainHeading)">
									All Approve
								</button>
							</div>

							<div v-else>
								<p>
									{{ mainHeading.value }}
								</p>
							</div>
						</th>
					</tr>
					<tr>
						<th
							v-for="(heading, index2) in data.headings"
							:key="index2"
							:class="{'large-width': heading.isWidth, 'main-heading-border-top': !data.headingMain.length}"
							:style="{'min-width': quickReports == 'day' || 'week' || 'month' ? '120px' : '', 'text-align': index2 == 0 ? 'left' : ''}"
							:colspan="heading.colspan"
						>
							{{ heading.value ? heading.value : "-" }}
						</th>
					</tr>

					<tr v-if="data.subHeading">
						<th
							v-for="(subHeading, shIndex) in data.subHeading"
							:key="shIndex"
							:colspan="subHeading.colspan"
						>
							{{ subHeading.value }}
						</th>
					</tr>
				</thead>

				<tbody>
					<tr v-for="(row, index3) in data.rows" :key="index3">
						<template v-for="(element, index4) in row">
							<td
								v-if="element.isClickable"
								:key="'data-row-if-'+index4"
								:style="{
									'text-align': index4 == 0 ? 'left' : '',
									'font-weight': index4 == 0 ? 'bold' : ''
								}"
							>
								<slot name="button" :element="element" :indexOfRow="index3" />
							</td>
							<td
								v-else
								:key="'data-row-else-'+index4"
								:style="[element.isconsolidatedRow ? { color: 'black', 'font-weight': 'bold' } : 'null']"
							>
								{{ element.value ? element.value : lastParamName ? lastParamName : "-" }}
							</td>
						</template>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="mt-2 pagination text-right">
			<el-pagination
				background
				:current-page.sync="pageInfo.currentPage"
				:page-sizes="[5, 10, 15, 20]"
				:page-size.sync="pageInfo.pageSize"
				layout="sizes, prev, pager, next"
				:total="tablePageCount"
				@size-change="handlePageInfoChange"
				@current-change="handlePageInfoChange"
			/>
		</div>
	</div>
</template>

<script>
import { mapState } from "vuex";
import { EventBus } from "../../eventBus";

export default {
	props: {
		tableData: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			noOfEntries: 10,
			currentPage: 1,
			pageSize: 10,
			pageInfo: {
				currentPage: 1,
				pageSize: 10
			},
			breadCrumbs: [],
			active_breadCrumbs: "",
			salesView: this.$route.name == "Location" ? "adt" : "contribution_sale",
			routeName: this.$route.name,
			allSalesView: [
				{
					name: "Average Daily Transaction",
					id: "adt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Sale",
					id: "amt",
					isVisible:
						this.$route.name == "Category" || this.$route.name == "Location"
				},
				{
					name: "Quantity",
					id: "sale",
					isVisible:
						this.$route.name == "Category"
				},
				{
					name: "Average Ticket Size",
					id: "at",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Item Per Transaction",
					id: "ipt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Contribution Amount",
					id: "contribution_amt",
					isVisible: this.$route.name == "Category" ? true : false
				},
				{
					name: "Contribution Sale (Units)",
					id: "contribution_sale",
					isVisible: this.$route.name == "Category" ? true : false
				}
				// {
				// 	name: "Sale Quantity",
				// 	id: "qty",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
				// {
				// 	name: "Contribution Margin",
				// 	id: "contribution_margin",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
			]
		};
	},
	computed: {
		...mapState("CommonStore", ["tablePageCount"]),
		quickReports() {
			return this.$store.getters.getQuickReports;
		},
		showViewDropdown() {
			return ["Location", "SalesStoreType"].some(
				_ => _ === this.routeName
			);
		},
		lastParamName() {
			if(this.breadCrumbs.length) {
				if(this.breadCrumbs.length == 3) {
					if(this.breadCrumbs[this.breadCrumbs.length - 1]) {
						let objectKeys = Object.keys(this.breadCrumbs[this.breadCrumbs.length - 1]);
						if(objectKeys[0]) {
							return objectKeys[0];
						} else {
							return "-";
						}
					} else {
						return "-";
					}
				} else if(this.breadCrumbs.length == 4) {
					if(this.breadCrumbs[this.breadCrumbs.length - 2]) {
						let objectKeys = Object.keys(this.breadCrumbs[this.breadCrumbs.length - 2]);
						if(objectKeys[0]) {
							return objectKeys[0];
						} else {
							return "-";
						}
					} else {
						return "-";
					}
				} else {
					return "-";
				}
			} else {
				return "-";
			}
		}
	},
	mounted() {
		EventBus.$on("resetPageInfoEvent", this.handleResetPageInfoEvent);
		EventBus.$on("disableFirstButton", payload => {
			this.disabled = payload;
		});
		EventBus.$on("breadCrumbs", data => {
			this.breadCrumbs = data;
		});
		EventBus.$on("activeBreadCrumb", data => {
			this.active_breadCrumbs = data;
		});
		var email = localStorage.getItem('user_email');
		if(email == 'rkhan@burgerking.in' || email == 'vdhanuka@burgerking.in' || email =='ukhemka@burgerking.in' || email == 'ssinha@burgerking.in' || email =='ntiwari@burgerking.in') {
			this.allSalesView = [
				{
					name: "Average Daily Transaction",
					id: "adt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Sale",
					id: "amt",
					isVisible:
						this.$route.name == "Category" || this.$route.name == "Location"
				},
				{
					name: "Quantity",
					id: "sale",
					isVisible:
						this.$route.name == "Category"
				},
				{
					name: "Item Per Transaction",
					id: "ipt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Contribution Amount",
					id: "contribution_amt",
					isVisible: this.$route.name == "Category" ? true : false
				},
				{
					name: "Contribution Sale (Units)",
					id: "contribution_sale",
					isVisible: this.$route.name == "Category" ? true : false
				}
				// {
				// 	name: "Sale Quantity",
				// 	id: "qty",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
				// {
				// 	name: "Contribution Margin",
				// 	id: "contribution_margin",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
			]
		} else {
			this.allSalesView = [
				{
					name: "Average Daily Transaction",
					id: "adt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Sale",
					id: "amt",
					isVisible:
						this.$route.name == "Category" || this.$route.name == "Location"
				},
				{
					name: "Quantity",
					id: "sale",
					isVisible:
						this.$route.name == "Category"
				},
				{
					name: "Average Ticket Size",
					id: "at",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Item Per Transaction",
					id: "ipt",
					isVisible: this.$route.name == "Location"
				},
				{
					name: "Contribution Amount",
					id: "contribution_amt",
					isVisible: this.$route.name == "Category" ? true : false
				},
				{
					name: "Contribution Sale (Units)",
					id: "contribution_sale",
					isVisible: this.$route.name == "Category" ? true : false
				}
				// {
				// 	name: "Sale Quantity",
				// 	id: "qty",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
				// {
				// 	name: "Contribution Margin",
				// 	id: "contribution_margin",
				// 	isVisible: this.$route.name == "Category" ? true : false
				// }
			]
		}
	},
	beforeDestroy() {
		EventBus.$off("resetPageInfoEvent", this.handleResetPageInfoEvent);
		EventBus.$off("disableFirstButton");
	},
	methods: {
		onSalesViewChange(salesView) {
			this.$store.commit('setSalesView', salesView);
			// EventBus.$emit("salesViewChanged", salesView);
		},
		downloadCsvEvent() {
			EventBus.$emit("downloadCsvEvent");
		},
		handleResetPageInfoEvent() {
			// console.log("resetting pageInfo");
			this.pageInfo.currentPage = 1;
			this.pageInfo.pageSize = 20;
		},
		handlePageInfoChange(val) {
			// debugger;
			const routeName = this.$route.name;
			// console.log("routename", this.$route.name);
			// console.log(`${val} items per page`);
			if (
				// if current page is greater than total pages then make the current page to the the last page.
				this.pageInfo.currentPage >
				this.tablePageCount / this.pageInfo.pageSize
			) {
				this.pageInfo.currentPage = Math.ceil(
					this.tablePageCount / this.pageInfo.pageSize
				);
			}
			// if (this.pageInfo.currentPage == 0) {
			// 	this.pageInfo.currentPage = 1;
			// }
			if (
				routeName == "forecastLocation" ||
				routeName == "forecastCategory" ||
				routeName == "forecastCentralKitchen"
			) {
				EventBus.$emit("pageInfoChangeForecastEvent", this.pageInfo);
			}
			if (routeName == "Location" || routeName == "Category") {
				EventBus.$emit("pageInfoChangeSalesEvent", this.pageInfo);
			}
		},
		// handleCurrentChange(val) {
		// 	const routeName = this.$route.name;
		// 	if (routeName == "forecastLocation" || routeName == "forecastCategory") {
		// 		EventBus.$emit("currentPageChangeForecastEvent", this.currentPage);
		// 	}
		// 	if (routeName == "Location" || routeName == "Category") {
		// 		EventBus.$emit("currentPageChangeSalesEvent", this.currentPage);
		// 	}
		// },
		breadCurmbClicked(selected_bredcrumb, element) {
			EventBus.$emit("activeBreadCrumb", selected_bredcrumb);
			const routeName = this.$route.name;
			if (
				routeName == "forecastLocation" ||
				routeName == "forecastCategory" ||
				routeName == "forecastCentralKitchen"
			) {
				EventBus.$emit(
					"clickBreadcurmbForecastEvent",
					selected_bredcrumb,
					element
				);
			}
			if (routeName == "Location" || routeName == "Category") {
				EventBus.$emit(
					"clickBreadcurmbSalesEvent",
					selected_bredcrumb,
					element
				);
			}
			if (routeName == "StoreType") {
				EventBus.$emit("clickBreadcurmbEvent", selected_bredcrumb, element);
			}
		},
		defaultBreadcurmbClicked() {
			const routeName = this.$route.name;
			if (
				routeName == "forecastLocation" ||
				routeName == "forecastCategory" ||
				routeName == "forecastCentralKitchen"
			) {
				EventBus.$emit("clickToShowInitialForecastData");
			}
			if (routeName == "Location" || routeName == "Category") {
				EventBus.$emit("clickToShowInitialSalesData");
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "./BaseTable.scss";
::-webkit-scrollbar-track {
	background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
	background: #c1c1c1;
}
::-webkit-scrollbar {
	height: 8px;
	overflow: visible;
	width: 8px;
}
</style>
<style lang="scss">
.AppLayout .el-pagination.is-background .el-pager li:not(.disabled).active {
	background-color: #f7ba89;
}
.AppLayout .el-pagination.is-background .el-pager li:not(.disabled):hover {
	color: #000;
}
.AppLayout .el-pagination .btn-next,
.AppLayout .el-pagination .btn-prev {
	border-radius: 50% !important;
}
.AppLayout .el-pager li {
	border-radius: 50% !important;
}
</style>
